import { render, staticRenderFns } from "./FormInputFloatingLabel.vue?vue&type=template&id=47a3a850&scoped=true&"
import script from "./FormInputFloatingLabel.vue?vue&type=script&lang=js&"
export * from "./FormInputFloatingLabel.vue?vue&type=script&lang=js&"
import style0 from "./FormInputFloatingLabel.vue?vue&type=style&index=0&id=47a3a850&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a3a850",
  null
  
)

export default component.exports